{
  "version": 1,
  "asset_id": "5e77115b-bb41-4521-9074-50d596edaa78",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/5e77115b-bb41-4521-9074-50d596edaa78/svc-technical-seo-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/5e77115b-bb41-4521-9074-50d596edaa78/svc-technical-seo-1200.avif",
  "original_filename": "svc-technical-seo-1200.avif",
  "size": 19642,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:58Z"
}
